{
	"titleFirstPart": "Bienvenido a la",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Carbono total almacenado"
}
